module.exports = __webpack_public_path__ + "static/media/number2.bf53dbd9.mp3";